var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.altTime},on:{"mouseover":function($event){_vm.hover = true},"mouseout":function($event){_vm.hover = false}}},[_vm._v("\n  "+_vm._s(_vm.hoverText && _vm.hover ? _vm.hoverText : _vm.formattedTimestamp)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }